module.exports = __webpack_public_path__ + "img/home-scandi-living.18404581.jpg";